export const EXPERIMENT_VARIATIONS = {
  CONTROL: 'control',
  TEST: 'test',
} as const;
